<!-- Footer -->
<section class="flex flex-auto justify-center w-full">
    <footer class="bg-white w-full sm:mb-0 px-4 py-8 dark:bg-slate-900">
        <div class="w-full sm:px-15">
            <!--Grid-->
            <div class="grid grid-cols-1 md:grid-cols-4 gap-8 py-3">
                <div class="flex flex-col items-center md:items-start">
                    <a class="flex justify-start mb-5" [routerLink]="'/'">
                        @if(view.site?.logoUrl) {
                        <img [alt]="view.site?.name" [src]="view.site?.logoUrl" class="w-80">
                        }
                    </a>
                    @if(view.site?.slogan) {
                    <p class="py-5 ml-1 text-primary-500 dark:text-white text-center text-2xl font-semibold">
                        {{view.site?.slogan}}
                    </p>
                    }
                </div>
                <!-- End Col -->

                <div class="w-full flex flex-col items-center md:items-start justify-start text-center md:text-left">
                    <h1 class="text-xl md:text-2xl lg:text-3xl tracking-wider mb-2">Contact</h1>

                    @if (view.site?.profile.heading.border == 1) {
                    <div class="flex items-baseline md:justify-start justify-center">
                        <span class="w-10 border-b-2 border-primary-500"></span>
                        <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                    </div>
                    }

                    <ul class="flex flex-col items-center md:items-start mt-3 space-y-3">
                        <li class="text-primary-500 text-md">
                            <a class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3"
                                    svgIcon="heroicons_outline:map"></mat-icon>
                                {{ view.site?.address }}
                            </a>
                        </li>
                        <li class="text-primary-500 text-md">
                            <a class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3"
                                    svgIcon="heroicons_outline:phone"></mat-icon>
                                {{ view.site?.telephone }}
                            </a>
                        </li>
                        <li class="text-primary-500 text-md cursor-pointer">
                            <a [href]="'mailto:' + view.site?.emailAddress" class="flex items-center">
                                <mat-icon class="icon-size-5 text-accent mr-3" svgIcon="feather:mail"></mat-icon>
                                {{ view.site?.emailAddress }}
                            </a>
                        </li>
                        @if(view.site?.id == 82) {
                            <li class="text-primary-500 cursor-pointer">
                                <a class="flex items-center">
                                    <mat-icon class="icon-size-5 text-accent mr-3"
                                        svgIcon="heroicons_outline:phone"></mat-icon>
                                        082 457 1954 (Emergency)
                                </a>
                            </li>
                        }
                    </ul>
                </div>
                <!-- End Col -->

                <div class="w-full flex flex-col items-center md:items-start justify-start text-center md:text-left">
                    <h1 class="text-xl md:text-2xl lg:text-3xl tracking-wider mb-2">Quick Links</h1>
                    @if (view.site?.profile.heading.border==1) {
                    <div class="flex items-baseline md:justify-start sm:justify-center">
                        <span class="w-10 border-b-2 border-primary-500"></span>
                        <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                    </div>
                    }
                    @if(view.site?.id === 79) {
                        <ul class="mt-3">
                            <li
                                class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500">
                                <a class="cursor-pointer text-primary-500" [routerLink]="['/media-center']">Newsletters</a>
                            </li>
                        </ul>
                    }
                    @if(view.site?.id === 89) {
                        <ul class="mt-3">
                            <li
                                class="transform transition-transform duration-300 hover:translate-x-2 hover:text-primary-500">
                                <a class="cursor-pointer text-primary-500" href="https://www.visitrussia.co.za/" target="_blank">Visit Russia</a>
                            </li>
                        </ul>
                    }
                </div>
                <!--End Col-->

                <div class="flex flex-col">
                    @if(view.site?.id != 89) {
                        <div class="flex mt-4 space-x-4 justify-center ">
                            @if(view.site?.socialUrlFacebook) {
                            <a href="{{view.site?.socialUrlFacebook}}" target="_blank"
                                class="group relative w-8 h-8 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:facebook'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.socialUrlInstagram) {
                            <a href="{{view.site?.socialUrlInstagram}}" target="_blank"
                                class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:instagram'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.socialUrlTwitter) {
                            <a href="{{view.site?.socialUrlTwitter}}" target="_blank"
                                class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:twitter'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.socialUrlLinkedIn) {
                            <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank"
                                class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:linkedin'"></mat-icon>
                            </a>
                            }
                            @if(view.site && view.site.id === 146 ) {
                            <a href="{{view.site?.socialUrlYouTube}}" target="_blank"
                                class="group relative w-8 h-8 mr-5 rounded-xl transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <mat-icon class="icon-size-4 text-white group-hover:text-primary"
                                    [svgIcon]="'feather:youtube'"></mat-icon>
                            </a>
                            }
                            @if(view.site?.socialUrlYouTube) {
                            <a href="https://www.xltravel.co.za/xlgo/" target="_blank"
                                class="group relative w-8 h-8 mr-5 rounded-full transition-all duration-500 flex justify-center items-center bg-primary-500 hover:bg-primary-100">
                                <img src="/assets/icons/xlgo-1.png" alt="">
                            </a>
                            }
                        </div>
                        <div class="flex justify-center items-center mt-20">
                            @if(view.site?.id != 79 && view.site?.id != 89) {
                            <div><img class="w-20" src="assets/images/logo/ASATA2.png" alt="ASATA logo"></div>
                            <div><img class="w-20" src="assets/images/logo/IATA.jpeg" alt="IATA logo"></div>
                            }
                        </div>
                    }
                    @if(view.site?.id == 89) {
                    <div class="flex flex-col items-center">
                        <!-- Row with two images -->
                        <div class="flex justify-center items-center">
                            <img class="h-30" src="assets/images/logo/IATA Accredited Agent.png" alt="IATA logo">
                            <img class="h-10" src="assets/xltravel/members/gsta.png" alt="GSTA logo">
                        </div>
                    
                        <!-- Paragraph below images, centered -->
                        <p class="text-sm uppercase text-primary-500 text-center font-semibold">
                            An associated member of the XL Group
                        </p>
                    </div>
                    }

                </div>
            </div>
            <div class="hidden md:grid grid-cols-5 gap-4 mt-10">
                @if(view.site?.id === 79) {
                <div class="flex items-center justify-start">
                    <img class="w-44" src="assets/images/logo/IATA Accredited Agent.png" alt="IATA logo">
                </div>
                <div class="flex items-center justify-start">
                    <img class="w-44" src="assets/images/logo/ASATA-logo.png" alt="ASATA Logo">
                </div>
                <div class="flex items-center justify-start">
                    <img class="w-44" src="assets/images/logo/Cape-Chamber-Logo.png" alt="Cape Chamber Logo">
                </div>
                <div class="flex items-center justify-center">
                    <img class="w-44" src="assets/images/logo/SKAL_logo.png" alt="Skal Logo">
                </div>
                <div class="flex items-center justify-center">
                    <img class="w-44" src="assets/xltravel/members/member-logo.png" alt="xl-Member Logo">
                </div>
                }
            </div>
             
            <!--Grid-->
            <div class="py-7 border-t border-gray-200">
                <div class="flex items-center justify-center flex-col lg:justify-between lg:flex-row">
                    <p class="text-sm text-center text-gray-500 dark:text-white">© Copyright &copy; {{currentYear}}
                        <span class="mx-1 text-primary-500">TravelFind.Me</span>(Pty) Ltd. All rights reserved.</p>
                    @if(view.pages) {
                    <ul class="flex items-center gap-9 mt-4 lg:mt-0">
                        @for(page of view.pages; track page) {
                        <li><a [routerLink]="['/policy', page.seo.alias]"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500">{{page.name}}</a>
                        </li>
                        }
                        @if(view.site?.id === 146) {
                        <li><a href="https://xltravel.co.za/PAIA%20Manual%20Template%20updated%20JS%2022%20June%202021%20-%2025%20June%202021.pdf"
                                target="_blank"
                                class="text-sm text-gray-500 dark:text-white hover:text-primary-500 cursor-pointer">PAIA
                                Manual</a></li>
                        }
                    </ul>
                    }
                </div>
            </div>
        </div>
    </footer>
</section>